import { httpClient } from '../http/httpClient'
import { SupportRequest } from '@/app/entities/SupportRequest'

export interface ReplySupportRequestParams {
  id: string
  message?: string
  files?: File[]
}

export async function replySupportRequest({
  id,
  message,
  files,
}: ReplySupportRequestParams) {
  const formData = new FormData()

  if (message?.trim()) {
    formData.append('message', message.trim())
  }

  files?.forEach((file) => {
    formData.append('files', file)
  })

  const { data } = await httpClient.post<SupportRequest>(
    `/support-requests/${id}/reply`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    },
  )

  return data
}
